module.exports = __webpack_public_path__ + "static/media/banner-GC01.8614af3b.jpg";